import { render } from "./searchspring-pagination.vue?vue&type=template&id=938803da"
import script from "./searchspring-pagination.vue?vue&type=script&lang=js"
export * from "./searchspring-pagination.vue?vue&type=script&lang=js"

import "./searchspring-pagination.vue?vue&type=style&index=0&id=938803da&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__